import React from "react";
import { Link } from "react-router-dom";

const FooterLinks = () => {

    return (
        <section className="elementor-section elementor-top-section elementor-element elementor-element-c695ad2 elementor-section-stretched specs-item-list elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="c695ad2" data-element_type="section" data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;,&quot;background_background&quot;:&quot;classic&quot;}" style={{width: '100%', left: '0px'}}>
            <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-1ae9ff4" data-id="1ae9ff4" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-1ebbccd elementor-widget elementor-widget-dc_element_by_specialities" data-id="1ebbccd" data-element_type="widget" data-widget_type="dc_element_by_specialities.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-by-skills dc-haslayout">
                                    <div className="dc-widgetskills">
                                        <div className="dc-fwidgettitle">
                                            <h3>By Speciality</h3>
                                        </div>
                                        <ul className="dc-fwidgetcontent">
                                            <li>
                                                <Link to={`/search-doctors/?specialities=allergy-immunology&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>Allergy &amp; Immunology</Link></li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=anesthesiology&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>Anesthesiology</Link></li>
                                            <li><Link to={`/search-doctors/?specialities=diagnostic-radiolog&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>Diagnostic radiology</Link></li>
                                            <li><Link to={`/search-doctors/?specialities=emergency-medicine&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>Emergency medicine</Link></li>
                                            <li><Link to={`/search-doctors/?specialities=surgery&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>Surgery</Link></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-9d22fb8" data-id="9d22fb8" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-57eaa99 elementor-widget elementor-widget-dc_element_specialities_loc" data-id="57eaa99" data-element_type="widget" data-widget_type="dc_element_specialities_loc.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-skill-location dc-haslayout">
                                    <div className="dc-widgetskills">
                                        <div className="dc-fwidgettitle">
                                            <h3>Doctors In US</h3>
                                        </div>
                                        <ul className="dc-fwidgetcontent">
                                            <li>
                                                <Link to={`/search-doctors/?specialities=allergy-immunology&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>
                                                    Allergy &amp; Immunology&nbsp;in&nbsp;Turkey								
                                                    </Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=anesthesiology&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>
                                                    Anesthesiology&nbsp;in&nbsp;Turkey								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=dermatology&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>
                                                    Dermatology&nbsp;in&nbsp;Turkey								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=radiation-oncology&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>
                                                    Radiation oncology&nbsp;in&nbsp;Turkey								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=surgery&amp;lat=38.9637&lng=35.2433&otherlocation=Turkey`}>
                                                    Surgery&nbsp;in&nbsp;Turkey								</Link>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-e0f1b0c" data-id="e0f1b0c" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-0f0e797 elementor-widget elementor-widget-dc_element_specialities_loc" data-id="0f0e797" data-element_type="widget" data-widget_type="dc_element_specialities_loc.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-skill-location dc-haslayout">
                                    <div className="dc-widgetskills">
                                        <div className="dc-fwidgettitle">
                                            <h3>Doctors In India</h3>
                                        </div>
                                        <ul className="dc-fwidgetcontent">
                                            <li>
                                                <Link to={`/search-doctors/?specialities=physical-medicine-rehabilitation&amp;lat=20.5937&lng=78.9629&otherlocation=India`}>
                                                    Physical medicine&nbsp;in&nbsp;India								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=preventive-medicine&amp;lat=20.5937&lng=78.9629&otherlocation=India`}>
                                                    Preventive medicine&nbsp;in&nbsp;India								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=psychiatry&amp;lat=20.5937&lng=78.9629&otherlocation=India`}>
                                                    Psychiatry&nbsp;in&nbsp;India								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=radiation-oncology&amp;lat=20.5937&lng=78.9629&otherlocation=India`}>
                                                    Radiation oncology&nbsp;in&nbsp;India								</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors/?specialities=surgery&amp;lat=20.5937&lng=78.9629&otherlocation=India`}>
                                                    Surgery&nbsp;in&nbsp;India								</Link>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-b18c319" data-id="b18c319" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-167a10c elementor-widget elementor-widget-dc_element_by_location" data-id="167a10c" data-element_type="widget" data-widget_type="dc_element_by_location.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-by-location dc-haslayout">
                                    <div className="dc-widgetskills">
                                        <div className="dc-fwidgettitle">
                                            <h3>By Location</h3>
                                        </div>
                                        <ul className="dc-fwidgetcontent">
                                            <li>
                                                <Link to={`/search-doctors?lat=55.3781&lng=-3.4360&page=1&otherlocation=United Kingdom (UK)`}>United Kingdom (UK)</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors?lat=20.5937&lng=78.9629&page=1&otherlocation=India`}>India</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors?lat=-25.2744&lng=133.7751&page=1&otherlocation=Australia`}>Australia</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors?lat=38.9637&lng=35.2433&page=1&otherlocation=Turkey`}>Turkey</Link>
                                            </li>
                                            <li>
                                                <Link to={`/search-doctors?lat=23.4241&lng=53.8478&page=1&otherlocation=United Arab Emirates`}>United Arab Emirates</Link>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FooterLinks;
